import React from 'react';
import Router from 'next/router';
import { ErrorLayout, MainLayout } from '@layouts';
import { getCourse } from '@modules/get-data';
import { getErrorContent, redirect } from '@libs';
import { LearningModulePage } from '@sections/Help-Center-Content';
import { ErrorContent } from '@components/Help-Center-Components';
import { ErrorConnection } from '@components/Help-Center-Components/error-connection';
import { HELP_CENTER, PROCESSING_ITEMS, IS_SERVER } from '@constants';
import * as actions from '@store/actions';

const HelpSection = ({ data }) => {
  return <LearningModulePage data={data} section={data.section} />;
};

HelpSection.getLayout = (page, { data, locale, statusCode, isDisconnect }) => {
  const { translations, query } = page.props;

  if (isDisconnect) {
    return (
      <ErrorLayout>
        <MainLayout>
          <ErrorConnection />
        </MainLayout>
      </ErrorLayout>
    );
  }

  if (statusCode) {
    const error = getErrorContent({ code: statusCode });

    return (
      <ErrorLayout title={translations.t(error.title)}>
        <MainLayout reqQuery={query}>
          <ErrorContent error={error} locale={locale} />
        </MainLayout>
      </ErrorLayout>
    );
  }

  const metaTitle = data.meta_title || `"${data.caption}" ${translations.t('site.help.metaTitleTemplate.site.module')}`;

  const metaDescription = data.meta_description || `${data.description}`;

  return (
    <MainLayout
      reqQuery={query}
      title={metaTitle}
      processing={PROCESSING_ITEMS.GET_HELP_SECTION}
      description={metaDescription}>
      {page}
    </MainLayout>
  );
};

HelpSection.getInitialProps = async ({ res, query, store }) => {
  const { module, page } = query;
  module;
  const section = HELP_CENTER.LEARNING_MODULES;
  const { dispatch, getState } = store;
  const {
    settings: { locale },
  } = getState();
  store.dispatch(actions.clearError('GET_HELP'));

  if (page === '1') {
    const path = `/${locale}/${HELP_CENTER.MAIN}/${section}/${module}`;
    if (IS_SERVER && res) {
      redirect(path, {}, 301, res);
    } else {
      Router.push(path);
    }
    return {};
  }

  const data = await dispatch(getCourse({ section, module }));

  const { errors } = getState();
  const error = errors[PROCESSING_ITEMS.GET_HELP];
  if (data.isDisconnect) {
    return { data, section, locale, isDisconnect: true };
  }
  if (error) {
    if (res && (error.code === 404 || error.code === 500)) {
      res.statusCode = error.code;
    }

    return { data, section, module, locale, statusCode: error.code || 404 };
  }

  return { data, section, module, locale, statusCode: undefined, query };
};

export default HelpSection;
